export default __webpack_public_path__ + "static/media/GPA_PotentialOutage_Banner.76a4f385.jpg";